import axiosClient from "./axiosClient";

// Backend routes (axiosClient.baseURL already includes /api/v1):
//   GET /users               → list all users with their role
//   PUT /users/{id}/role     → change a user's role (body: { roleId })
const usersAdminApi = {
  list: () => axiosClient.get("/users"),
  changeRole: (userId, roleId) =>
    axiosClient.put(`/users/${userId}/role`, { roleId }),
};

export default usersAdminApi;